import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgUserNotFound = (props) => /* @__PURE__ */ _jsxs("svg", {
	preserveAspectRatio: "none",
	overflow: "visible",
	style: { display: "block" },
	width: 54.5804,
	height: 53.694,
	viewBox: "0 0 54.5804 53.694",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		id: "Group 2147234924",
		children: [
			/* @__PURE__ */ _jsx("g", {
				id: "Vector",
				filter: "url(#filter0_iii_0_26)",
				children: /* @__PURE__ */ _jsx("path", {
					d: "M48.0733 45.422C47.9101 45.7039 47.6754 45.9379 47.3928 46.1006C47.1102 46.2633 46.7896 46.3489 46.4633 46.3489H1.8567C1.53061 46.3485 1.21034 46.2626 0.928066 46.0998C0.645787 45.937 0.411431 45.7029 0.24853 45.4212C0.0856285 45.1394 -8.36565e-05 44.8199 6.12685e-08 44.4947C8.3779e-05 44.1694 0.0859603 43.85 0.249007 43.5683C3.78733 37.4673 9.24002 33.0926 15.6034 31.0187C12.4558 29.1499 10.0103 26.3022 8.64245 22.913C7.27461 19.5237 7.06007 15.7804 8.03179 12.2578C9.0035 8.73518 11.1077 5.6281 14.0213 3.4137C16.935 1.19929 20.4968 0 24.16 0C27.8231 0 31.385 1.19929 34.2986 3.4137C37.2122 5.6281 39.3165 8.73518 40.2882 12.2578C41.2599 15.7804 41.0454 19.5237 39.6775 22.913C38.3097 26.3022 35.8642 29.1499 32.7166 31.0187C39.08 33.0926 44.5327 37.4673 48.071 43.5683C48.2345 43.8499 48.3207 44.1695 48.3211 44.4948C48.3216 44.8202 48.2361 45.14 48.0733 45.422Z",
					fill: "url(#paint0_linear_0_26)"
				})
			}),
			/* @__PURE__ */ _jsx("foreignObject", {
				x: 1.51823,
				y: .631794,
				width: 71.7288,
				height: 71.7289,
				children: /* @__PURE__ */ _jsx("div", {
					xmlns: "http://www.w3.org/1999/xhtml",
					style: {
						backdropFilter: "blur(9.33px)",
						clipPath: "url(#bgblur_0_0_26_clip_path)",
						height: "100%",
						width: "100%"
					}
				})
			}),
			/* @__PURE__ */ _jsx("g", {
				id: "Union",
				filter: "url(#filter1_ii_0_26)",
				"data-figma-bg-blur-radius": 18.6667,
				children: /* @__PURE__ */ _jsx("path", {
					d: "M50.9889 47.0403C50.0438 46.0952 49.9675 44.6061 50.6181 43.4385C54.0623 37.2581 53.1589 29.3059 47.908 24.055C41.5659 17.713 31.2835 17.713 24.9414 24.055C18.5994 30.397 18.5994 40.6795 24.9414 47.0216C30.1924 52.2725 38.1445 53.1759 44.3249 49.7317C45.4925 49.081 46.9816 49.1574 47.9267 50.1025L51.1839 53.3597C51.6296 53.8054 52.3522 53.8054 52.7979 53.3597L54.2461 51.9115C54.6918 51.4658 54.6918 50.7432 54.2461 50.2975L50.9889 47.0403Z",
					fillRule: "evenodd",
					clipRule: "evenodd",
					fill: "#99C1FD",
					fillOpacity: .5
				})
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "?",
				d: "M36.0037 40.0924C35.788 40.0924 35.613 39.9175 35.613 39.7018C35.613 39.0277 35.7203 38.4302 35.9348 37.9093C36.1646 37.3884 36.448 36.9211 36.7851 36.5075C37.1374 36.0785 37.4975 35.6878 37.8651 35.3354C38.386 34.8452 38.8456 34.3703 39.244 33.9106C39.6576 33.451 39.8645 32.9148 39.8645 32.302C39.8645 31.919 39.7725 31.5743 39.5887 31.2679C39.4048 30.9462 39.1291 30.6934 38.7614 30.5095C38.409 30.3104 37.9724 30.2108 37.4515 30.2108C36.7314 30.2108 36.111 30.4329 35.5901 30.8772C35.4045 31.0346 35.2438 31.2126 35.1078 31.4113C34.7036 32.0017 34.0421 32.485 33.3461 32.3193C32.707 32.1671 32.2757 31.537 32.52 30.9272C32.6768 30.536 32.8805 30.1746 33.1311 29.8431C33.6214 29.1996 34.2342 28.7017 34.9696 28.3493C35.7203 27.9817 36.5629 27.7978 37.4975 27.7978C38.5546 27.7978 39.4585 28.0123 40.2092 28.4413C40.9752 28.8549 41.5574 29.3988 41.9557 30.0729C42.354 30.747 42.5532 31.4747 42.5532 32.256C42.5532 32.8842 42.423 33.451 42.1625 33.9566C41.9174 34.4469 41.5957 34.8988 41.1973 35.3125C40.8143 35.7261 40.416 36.1321 40.0023 36.5304C39.5121 37.0054 39.0755 37.5033 38.6924 38.0242C38.3248 38.5298 38.1409 39.1272 38.1409 39.8167C38.1409 39.969 38.0174 40.0924 37.8651 40.0924H36.0037ZM36.9205 45.1941C36.1984 45.1941 35.613 44.6088 35.613 43.8867C35.613 43.1646 36.1984 42.5792 36.9205 42.5792H36.9484C37.6704 42.5792 38.2558 43.1646 38.2558 43.8867C38.2558 44.6088 37.6704 45.1941 36.9484 45.1941H36.9205Z",
				fill: "white"
			})
		]
	}), /* @__PURE__ */ _jsxs("defs", { children: [
		/* @__PURE__ */ _jsxs("filter", {
			id: "filter0_iii_0_26",
			x: -2.66667,
			y: -18.6667,
			width: 69.6545,
			height: 67.6822,
			filterUnits: "userSpaceOnUse",
			colorInterpolationFilters: "sRGB",
			children: [
				/* @__PURE__ */ _jsx("feFlood", {
					floodOpacity: 0,
					result: "BackgroundImageFix"
				}),
				/* @__PURE__ */ _jsx("feBlend", {
					mode: "normal",
					in: "SourceGraphic",
					in2: "BackgroundImageFix",
					result: "shape"
				}),
				/* @__PURE__ */ _jsx("feColorMatrix", {
					in: "SourceAlpha",
					type: "matrix",
					values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
					result: "hardAlpha"
				}),
				/* @__PURE__ */ _jsx("feOffset", {
					dx: -2.66667,
					dy: 2.66667
				}),
				/* @__PURE__ */ _jsx("feGaussianBlur", { stdDeviation: 9.33333 }),
				/* @__PURE__ */ _jsx("feComposite", {
					in2: "hardAlpha",
					operator: "arithmetic",
					k2: -1,
					k3: 1
				}),
				/* @__PURE__ */ _jsx("feColorMatrix", {
					type: "matrix",
					values: "0 0 0 0 0.0117647 0 0 0 0 0.0784314 0 0 0 0 0.180392 0 0 0 0.1 0"
				}),
				/* @__PURE__ */ _jsx("feBlend", {
					mode: "normal",
					in2: "shape",
					result: "effect1_innerShadow_0_26"
				}),
				/* @__PURE__ */ _jsx("feColorMatrix", {
					in: "SourceAlpha",
					type: "matrix",
					values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
					result: "hardAlpha"
				}),
				/* @__PURE__ */ _jsx("feOffset", {
					dx: 18.6667,
					dy: -18.6667
				}),
				/* @__PURE__ */ _jsx("feGaussianBlur", { stdDeviation: 16 }),
				/* @__PURE__ */ _jsx("feComposite", {
					in2: "hardAlpha",
					operator: "arithmetic",
					k2: -1,
					k3: 1
				}),
				/* @__PURE__ */ _jsx("feColorMatrix", {
					type: "matrix",
					values: "0 0 0 0 0.0392157 0 0 0 0 0.0392157 0 0 0 0 0.0392157 0 0 0 0.1 0"
				}),
				/* @__PURE__ */ _jsx("feBlend", {
					mode: "normal",
					in2: "effect1_innerShadow_0_26",
					result: "effect2_innerShadow_0_26"
				}),
				/* @__PURE__ */ _jsx("feColorMatrix", {
					in: "SourceAlpha",
					type: "matrix",
					values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
					result: "hardAlpha"
				}),
				/* @__PURE__ */ _jsx("feOffset", { dy: -2.66667 }),
				/* @__PURE__ */ _jsx("feGaussianBlur", { stdDeviation: 1.33333 }),
				/* @__PURE__ */ _jsx("feComposite", {
					in2: "hardAlpha",
					operator: "arithmetic",
					k2: -1,
					k3: 1
				}),
				/* @__PURE__ */ _jsx("feColorMatrix", {
					type: "matrix",
					values: "0 0 0 0 0.0392157 0 0 0 0 0.0392157 0 0 0 0 0.0392157 0 0 0 0.2 0"
				}),
				/* @__PURE__ */ _jsx("feBlend", {
					mode: "normal",
					in2: "effect2_innerShadow_0_26",
					result: "effect3_innerShadow_0_26"
				})
			]
		}),
		/* @__PURE__ */ _jsxs("filter", {
			id: "filter1_ii_0_26",
			x: 1.51823,
			y: .631794,
			width: 71.7288,
			height: 71.7289,
			filterUnits: "userSpaceOnUse",
			colorInterpolationFilters: "sRGB",
			children: [
				/* @__PURE__ */ _jsx("feFlood", {
					floodOpacity: 0,
					result: "BackgroundImageFix"
				}),
				/* @__PURE__ */ _jsx("feBlend", {
					mode: "normal",
					in: "SourceGraphic",
					in2: "BackgroundImageFix",
					result: "shape"
				}),
				/* @__PURE__ */ _jsx("feColorMatrix", {
					in: "SourceAlpha",
					type: "matrix",
					values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
					result: "hardAlpha"
				}),
				/* @__PURE__ */ _jsx("feOffset", { dy: -5.33333 }),
				/* @__PURE__ */ _jsx("feGaussianBlur", { stdDeviation: 1.33333 }),
				/* @__PURE__ */ _jsx("feComposite", {
					in2: "hardAlpha",
					operator: "arithmetic",
					k2: -1,
					k3: 1
				}),
				/* @__PURE__ */ _jsx("feColorMatrix", {
					type: "matrix",
					values: "0 0 0 0 0.0392157 0 0 0 0 0.0392157 0 0 0 0 0.0392157 0 0 0 0.1 0"
				}),
				/* @__PURE__ */ _jsx("feBlend", {
					mode: "normal",
					in2: "shape",
					result: "effect1_innerShadow_0_26"
				}),
				/* @__PURE__ */ _jsx("feColorMatrix", {
					in: "SourceAlpha",
					type: "matrix",
					values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
					result: "hardAlpha"
				}),
				/* @__PURE__ */ _jsx("feOffset", {
					dx: 2.66667,
					dy: 5.33333
				}),
				/* @__PURE__ */ _jsx("feGaussianBlur", { stdDeviation: 1.33333 }),
				/* @__PURE__ */ _jsx("feComposite", {
					in2: "hardAlpha",
					operator: "arithmetic",
					k2: -1,
					k3: 1
				}),
				/* @__PURE__ */ _jsx("feColorMatrix", {
					type: "matrix",
					values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.15 0"
				}),
				/* @__PURE__ */ _jsx("feBlend", {
					mode: "normal",
					in2: "effect1_innerShadow_0_26",
					result: "effect2_innerShadow_0_26"
				})
			]
		}),
		/* @__PURE__ */ _jsx("clipPath", {
			id: "bgblur_0_0_26_clip_path",
			transform: "translate(-1.51823 -0.631794)",
			children: /* @__PURE__ */ _jsx("path", {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M50.9889 47.0403C50.0438 46.0952 49.9675 44.6061 50.6181 43.4385C54.0623 37.2581 53.1589 29.3059 47.908 24.055C41.5659 17.713 31.2835 17.713 24.9414 24.055C18.5994 30.397 18.5994 40.6795 24.9414 47.0216C30.1924 52.2725 38.1445 53.1759 44.3249 49.7317C45.4925 49.081 46.9816 49.1574 47.9267 50.1025L51.1839 53.3597C51.6296 53.8054 52.3522 53.8054 52.7979 53.3597L54.2461 51.9115C54.6918 51.4658 54.6918 50.7432 54.2461 50.2975L50.9889 47.0403Z"
			})
		}),
		/* @__PURE__ */ _jsxs("linearGradient", {
			id: "paint0_linear_0_26",
			x1: 13.3586,
			y1: 13.3008,
			x2: 66.5456,
			y2: 41.7217,
			gradientUnits: "userSpaceOnUse",
			children: [/* @__PURE__ */ _jsx("stop", { stopColor: "#0064FA" }), /* @__PURE__ */ _jsx("stop", {
				offset: 1,
				stopColor: "#00D3F3"
			})]
		})
	] })]
});
export default SvgUserNotFound;
